export const IMAGE_SLIDER_PROP = {
  ADVANCED_OPTIONS: "advancedOptions",
  BORDER_RADIUS: "borderRadius",
  TEXT_ALIGNMENT: "textAlignment",
  TITLE_ALIGNMENT: "titleAlignment",
  TEXT_SIZE: "textSize",
  TITLE_SIZE: "titleSize",
  ARROWS: "arrows",
  AUTOPLAY: "autoplay",
  BULLETS: "bullets",
  HAS_TITLE: "hasTitle",
  HEIGHT: "height",
  IMAGES: "images",
  ROUNDED_CORNERS: "roundedCorners",
  THUMBNAILS: "thumbnails",
  TITLE: "title",
  VIEW_TYPE: "viewType",
  DESCRIPTION: "description",
  LINK_TO_PAGE: "linkToPage",
  NEW_TAB: "newTab",
  LINK: "link",
  SOURCE: "source",
  HAS_IMAGES_TITLE: "hasImagesTitle",
  HAS_IMAGES_DESCRIPTION: "hasImagesDescription",
  ASPECT_RATIO: "aspectRatio",
  ORIGINAL: "original",
  SQUARED: "squared",
};

export const IMAGE_SLIDER_DESIGN = {
  SLIDER_ONE: "slider-one",
  SLIDER_TWO: "slider-two",
};

export const DEFAULT_IMAGE_PROPS = {
  title: "",
  description: "",
  linkToPage: {
    id: "",
    link: "",
    title: "",
    type: "",
    source: "page",
    newTab: false,
  },
};

export const DESIGNS_OPTIONS = {
  TITLE: [IMAGE_SLIDER_DESIGN.SLIDER_ONE, IMAGE_SLIDER_DESIGN.SLIDER_TWO],
  SUBTEXT: [IMAGE_SLIDER_DESIGN.SLIDER_ONE],
  CONTENT: [IMAGE_SLIDER_DESIGN.SLIDER_TWO],
  IMAGE_CONTENT: [IMAGE_SLIDER_DESIGN.SLIDER_ONE],
};
